<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingEstabelecimentos"
        @add="$router.push({ path: '/estabelecimento' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador, Código Oficial, Nome ou Status" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingEstabelecimentos"
                    :must-sort="true" :items="estabelecimentos" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'


export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idEstabelecimento', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Estabelecimentos',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idEstabelecimento' },
            { text: 'Código Oficial', value: 'nrCodigoOficial' },
            { text: 'Nome', value: 'nmEstabelecimento' },
            { text: 'Município', value: 'nmMunicipio' },
        ],
        estabelecimentos: [],
        isLoadingEstabelecimentos: false,
        isErrorEstabelecimento: false,
        query: {},
        search: '',
    }),
    computed: {
        municipios () {
            return this.$store.state.municipios
        },
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
    },
    methods: {
        toEstabelecimentosView(entry) {
            let nmMunicipio = this.municipios.find(x => x.idMunicipio == entry.cdMunicipio).nmMunicipio
            return {...entry, nmMunicipio}
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadUFs')
            this.$store.dispatch('actLoadMunicipios')
            this.query = Object.assign({}, route.query)
        },
        editItem (value) {
            this.$router.push({ name: 'estabelecimento', params: { id : value.idEstabelecimento } })
        },
        searchItem() {
            var context = this
            if (this.idPlantaAbate == 0) return

            var search = Object.assign({}, this.query)

            this.isLoadingEstabelecimentos = true

            this.$axios.get(this.urlAPIEstabelecimento + 'estabelecimento/', { params: search })
                .then((response) => {
                    this.estabelecimentos = response.data ? response.data.map(this.toEstabelecimentosView) : []
                })
                .catch((error) => {
                    this.isErrorEstabelecimento = true
                    this.$store.commit("setSnack", { type: "error", msg: error })
                })
                .finally(() => {
                    this.isLoadingEstabelecimentos = false
                })
        },
        routeUpdate() {
            this.$router.push({ path : 'estabelecimentoSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        'municipios' (newValue) {
            if (newValue)
            {
                this.searchItem()
            }
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
